import React from "react";
/**
 * 認証状態を管理するReact Context
 */
export const AuthContext = React.createContext(null);
AuthContext.displayName = "AuthContext";
